export enum QueryKeys {
  USERNAME = "username",
  USER_METADATA = "userMetadata",
  POINTS = "points",
  TOTAL_POINTS = "totalPoints",
  SESSION = "session",
  TAGS = "tags",
  USER_LINKS = "userLinks",
  USER_LIKED_LINKS = "userLikedLinks",
  ALL_LINKS = "allLinks",
}
